import React from 'react'
import styles from './Chip.module.scss'
import Pattern1 from './../../../../assets/images/Pattern1.png'
import Pattern2 from './../../../../assets/images/Pattern2.png'
import Pattern4 from './../../../../assets/images/Pattern3.png'
import Pattern3 from './../../../../assets/images/Pattern4.png'

const chip = (props) => {

	const patterns = {
		1: <div>
			<img src={Pattern1}  className={styles.chipImage} />
		</div>,
		2: <div>
			<img src={Pattern2} className={styles.chipImage}/>
		</div>,
		3: <div>
			<img src={Pattern3} className={styles.chipImage}/>
		</div>,
		4: <div>
			<img src={Pattern4} className={styles.chipImage}/>
		</div>
	}

	return (
		<div className={[styles.Chip, styles.pattern, styles[`pattern-${props.chipType}`]].join(' ')}>
			{patterns[props.chipType]}
			<h5>{props.label}</h5>
		</div>
	)
}

export default chip
